import { makeStyles } from '@vitessce/styles';
export const useStyles = makeStyles()(() => ({
    vegaContainer: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
    },
}));
//# sourceMappingURL=styles.js.map